/* eslint-disable react/no-unknown-property */
import { Card } from 'flowbite-react';
import { motion } from 'framer-motion';
import Navbarsection from './Navbarsection';
import Footersection from './Footersection';

// Animation Variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2 }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.5, ease: "easeOut" }
  }
};

const features = [
  {
    title: "Expertise & Experience",
    description: "Our team brings decades of combined experience in social advocacy, ensuring every initiative is backed by proven strategies and deep domain knowledge.",
    img: "/images/blog/image-1.jpg",
    icon: <path d="M12 14l9-5-9-5-9 5 9 5zm0 0l9-5-9-5-9 5 9 5zm0 0v6.5L21 16l-9-5.5z" />
  },
  {
    title: "Holistic Support",
    description: "We don't just provide aid; we provide a future. From mental health counseling to vocational training, we address the root causes of social challenges.",
    img: "/images/blog/image-2.jpg",
    icon: <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
  },
  {
    title: "Path to Self-Reliance",
    description: "Empowerment is our metric for success. We equip individuals with the tools and confidence to lead independent, dignified lives within their communities.",
    img: "/images/blog/image-3.jpg",
    icon: <path d="M13 10V3L4 14h7v7l9-11h-7z" />
  },
  {
    title: "Systemic Advocacy",
    description: "We leverage our influence to challenge unfair policies and advocate for systemic changes that create a more equitable society for everyone.",
    img: "/images/blog/image-4.jpg",
    icon: <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z" />
  }
];

export default function WhyUs() {
  return (
    <div className="">
      <Navbarsection />

      {/* Hero Header */}
      <section className="relative py-20 px-4">
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-3xl mx-auto text-center"
        >
          <h2 className="text-orange-600 font-bold uppercase tracking-widest text-sm mb-3">
            Why Partner With Us
          </h2>
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6">
            Making an Impact That Lasts
          </h1>
          <p className="text-gray-600 text-lg leading-relaxed">
            We are dedicated to fostering a world where every individual has the opportunity to thrive through specialized care and strategic advocacy.
          </p>
        </motion.div>
      </section>

      {/* Grid Section */}
      <section className="pb-24 px-4 lg:px-8">
        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4 max-w-7xl mx-auto"
        >
          {features.map((item, index) => (
            <motion.div key={index} variants={itemVariants}>
              <Card 
                className="h-full group hover:shadow-2xl transition-all duration-500 border-none rounded-2xl overflow-hidden"
                imgSrc={item.img}
              >
                <div className="flex flex-col h-full">
                  {/* Icon Badge */}
                  <div className="w-12 h-12 bg-indigo-100 text-indigo-600 rounded-xl flex items-center justify-center mb-5 group-hover:bg-orange-500 group-hover:text-white transition-colors duration-300">
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      {item.icon}
                    </svg>
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-orange-600 transition-colors">
                    {item.title}
                  </h3>
                  
                  <p className="text-gray-600 leading-relaxed text-sm">
                    {item.description}
                  </p>
                </div>
              </Card>
            </motion.div>
          ))}
        </motion.div>
      </section>

      <Footersection />
    </div>
  );
}